import styled from "styled-components"

export const SearchWrapper = styled.div`
    min-height: 70vh;
    .title_container{
        border-radius: 5px;
        box-shadow: 0px 4px 8px rgb(34 24 24 / 20%);
    }
    .filter{
        box-shadow: 0px 4px 8px rgb(34 24 24 / 20%);
        border-radius: 5px;
    }
    .empty_data{
        min-height: 400px;
    }
`
